import React from 'react';
import { Row, Col, FormGroup } from 'react-bootstrap';
import { CheckBox, RichTextEditor } from 'fw/forms';
import { SetupTab } from 'areas/shared/pages/setup';
import { Label } from 'fw/components';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'

class TooltipManagerInfoTab extends SetupTab {
    
    initialForm() {
        return {
            text:"",
            active: true,
            rowVersion: null
        }
    }

    privileges() {
        return {
            edit: App.hasPrivilege("AdminTooltipManagerSetupEdit")
        }
    }

    urls() {
        return {
            get: API.App.url('/tooltipManagerSetup/getTooltipManagerInfo'),
            save: API.App.url('/tooltipManagerSetup/saveTooltipManagerInfo'),
        }
    }

    getRequest(selectedId) {
        return {
            tooltipCode: selectedId
        }
    }

    saveRequest() {
        return {
            tooltipCode: this.props.selectedId,
            text: this.state.form.text,
            active: this.state.form.active,
            rowVersion: this.state.form.rowVersion
        }
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <CheckBox name="active" label="Active" />
                    </Col>
                    <Col md={12}>
                        <FormGroup>
                        <Label required>Text</Label>
                            <RichTextEditor enabled="true" name="text" />
                        </FormGroup>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default TooltipManagerInfoTab;


// WEBPACK FOOTER //
// ./src/areas/admin/tooltipManagerSetup/tooltipManagerInfo/TooltipManagerInfoTab.js